module.exports = __webpack_public_path__ + "static/media/49_A.a0727407.png";